export enum OnboardingSettingsTab {
  InvestorAndReviewSettings = 'investor-and-review-settings',
  KycSettings = 'kyc-settings',
  KybSettings = 'kyb-settings',
  TaxSettings = 'tax-settings',
}
